import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "../firebase"; // adjust path if needed

const Careers = () => {
  const navigate = useNavigate();

  const [jobs, setJobs] = useState([]);
  // const [categories, setCategories] = useState(["All"]);
  const categories = [
    "All",
    "Engineering",
    "Management",
    "Sales",
    "HR",
    "Creative",
  ];
  const [activeCategory, setActiveCategory] = useState("All");
  const [loading, setLoading] = useState(true);

  // ===============================
  // 🔹 FETCH JOBS FROM FIREBASE
  // ===============================
  useEffect(() => {
    const fetchJobs = async () => {
      try {
        const snapshot = await getDocs(collection(db, "jobs"));
        const data = snapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        setJobs(data);

        // build unique categories dynamically
        const filteredJobs =
          activeCategory === "All"
            ? jobs
            : jobs.filter((job) => job.category === activeCategory);
      } catch (error) {
        console.error("Error fetching jobs:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchJobs();
  }, []);

  useEffect(() => {
    console.log("🔥 Jobs in Careers:", jobs);
  }, [jobs]);

  // ===============================
  // 🔹 FILTER BY CATEGORY
  // ===============================
  const filteredJobs =
    activeCategory === "All"
      ? jobs
      : jobs.filter((job) => job.category === activeCategory);

  return (
    <div className="min-h-screen bg-[var(--bg-1)]">
      {/* 🔹 HERO SECTION */}
      <div
        className="h-[300px] flex items-center justify-center text-center"
        style={{
          backgroundImage:
            "linear-gradient(rgba(6,40,68,.75), rgba(6,40,68,.75)), url('/career.jfif')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <div>
          <h1 className="text-4xl md:text-5xl font-bold text-white mb-3">
            Careers at DVV Projects
          </h1>
          <p className="text-gray-200 text-lg">
            Build your future with us in Visakhapatnam
          </p>
        </div>
      </div>

      {/* 🔹 CATEGORIES */}
      <div className="py-8 border-b bg-[var(--bg-1)] px-4">
        <div className="grid grid-cols-2 gap-3 md:flex md:gap-4 md:justify-center">
          {categories.map((cat) => (
            <button
              key={cat}
              onClick={() => setActiveCategory(cat)}
              className={`px-4 py-2 rounded-full text-sm font-medium transition
          ${
            activeCategory === cat
              ? "bg-[var(--brand-dark)] text-white"
              : "bg-white text-[var(--brand-dark)] border"
          }`}
            >
              {cat}
            </button>
          ))}
        </div>
      </div>

      {/* 🔹 JOB LIST */}
      <div className="max-w-6xl mx-auto px-4 py-12">
        {loading ? (
          <p className="text-center text-gray-500">Loading jobs...</p>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-6">
            {filteredJobs.map((job) => (
              <div
                key={job.id}
                onClick={() => navigate(`/careers/${job.slug}`)} // 🔴 IMPORTANT: id, not slug
                className="group bg-white flex items-center justify-between
                           px-6 py-5 rounded-md border border-gray-200
                           cursor-pointer transition
                           hover:border-[var(--brand-gold)]
                           hover:shadow-sm"
              >
                {/* LEFT CONTENT */}
                <div>
                  <h2 className="text-xl font-semibold text-brand-dark mb-1">
                    {job.title}
                  </h2>
                  <p className="text-sm text-gray-500">
                    {job.createdAt?.toDate
                      ? job.createdAt.toDate().toLocaleDateString()
                      : ""}{" "}
                    | {job.location}
                  </p>
                </div>

                {/* RIGHT ARROW */}
                <ArrowRight
                  size={22}
                  className="text-brand-gold transition-transform
                             group-hover:translate-x-1"
                />
              </div>
            ))}

            {filteredJobs.length === 0 && (
              <p className="text-gray-500 col-span-2 text-center">
                No jobs available in this category.
              </p>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Careers;
